import React from "react"
import { NA } from "../../../constants"
import { MathKatex2 } from "../../../components/MathKatex"
import { getBellringerQuestionForReview, getBellringerSetNumber, getBellringersImageURL, getQuestionReviewInfoForTeacher, IBellringersTestQuestionEx } from "../../../services/bellringers"
import { ScantronBubble } from '../../Practice/components/ScantronBubble';

const iconCorrect = "/assets/images/icons/v2/ico-answer-status-correct.svg"
const iconIncorrect = "/assets/images/icons/v2/ico-answer-status-incorrect.svg"

interface Props {
    bellringerId: string
    info: any
    onClose: () => void
}

interface State {
    bellringerRevievQuestion?: IBellringersTestQuestionEx
}

export default class BellringerQuestionReviewForTeacher extends React.Component<Props, State> {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    async componentDidMount() {
        let {bellringerId, info} = this.props
        let bellringerRevievQuestion = await getBellringerQuestionForReview(bellringerId)
        this.setState({bellringerRevievQuestion})
    }

    render() {
        let {bellringerRevievQuestion} = this.state

        if (!bellringerRevievQuestion) return null

        let {info, onClose} = this.props
        let {bellringerQuestionStats} = info
        let reviewInfo = getQuestionReviewInfoForTeacher(bellringerRevievQuestion, bellringerQuestionStats)
        let {question} = reviewInfo
        let {subject, grade, week, questionNo} = question
        let setNo = getBellringerSetNumber(grade)
        let title = `${subject} Set: ${setNo} Week: ${week} Question: ${questionNo}`
        return (
            <div
                className="modal-content sat-explanation modal modal-tsg"
                style={{maxWidth: "1290px"}}
            >
                <div className="modal-body">

                    <div className={`modal-tsg--header mb-0 theme-heading--${subject.toLowerCase()} text-left`}>
                        <div className="col-lg-12">
                            <h2 className="mb-0">{title}</h2>
                        </div>

                        <button
                            type="button"
                            className="modal-close"
                            title="Close Modal"
                            aria-label="Close"
                            onClick={onClose}
                        >
                            <img
                                alt=""
                                className="modal-icon"
                                src="/assets/images/icons/v2/ico-modal-close.svg"
                                width="24"
                                height="24"
                            />
                        </button>
                    </div>
                    <StatsView info={reviewInfo} />
                    <div className="modal-tsg--inner">
                        <div className="question-explanation-sat">
                            <div className="container-fluid px-0">
                                <div className="row">
                                    <div className="col-md-6 mb-4 mb-md-0">
                                        <QuestionView info={reviewInfo} />
                                    </div>
                                    <div className="col-md-6">
                                        <ExplanationsView info={reviewInfo} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

//--- Helpers ---

function StatsView({info}) {
    let {question, displayInfo, stats, distractorAnswer} = info
    let {correctAnswer} = question

    let {
        infoOverallAccuracy,
        infoAverageTime,
        infoAverageLowest,
        infoAverageHighest
    } = displayInfo

    let {answerTotal} = stats

    let statsInfo = {
        stats,
        correctAnswer,
        distractorAnswer
    }

    return (
        <div className="stats-view--wrapper">
            <div className="stats-view">
                <div className="stats-view--stats">
                    <div>
                        <b>Overall Accuracy:</b> {infoOverallAccuracy}
                    </div>

                    <span className="stats-view--divider"></span>

                    <div>
                        <b>Average Time:</b> {infoAverageTime}
                    </div>

                    <span className="stats-view--divider"></span>

                    <div>
                        <b>Min-Max Time:</b> [{infoAverageLowest} - {infoAverageHighest}]
                    </div>

                    <span className="stats-view--divider"></span>

                    <div>
                        <b>Total Answers:</b> {answerTotal}
                    </div>
                </div>
                <div className="stats-view--answers">

                {/* <span className="mx-3">|</span> */}

                <AnswerStats info={statsInfo}/>
                </div>

            </div>
        </div>
    )
}

function getPercentage(val) {
    return Math.round(100*val)
}

function getPercentageInfo(val: number) {
    if (val < 0) return NA
    return `${getPercentage(val)}%`
}

function getAverageInfoForAnswer(stats, answer: string) {
    let {answerTotal, answerCountA, answerCountB, answerCountC, answerCountD} = stats
    let targetAnswer  = 
        answer === "A" ? answerCountA: 
        answer === "B" ? answerCountB:
        answer === "C" ? answerCountC:
        answer === "D" ? answerCountD: 0
    let average = targetAnswer / answerTotal

    return `${getPercentageInfo(average)}`
}

function AnswerStats({info}) {
    let {stats, correctAnswer, distractorAnswer} = info
    let {answerTotal, answerCountA, answerCountB, answerCountC, answerCountD} = stats

    if (answerTotal <= 0) return null

    let answers = ["A", "B", "C", "D"]

     return (
        <div className="d-flex answerStats">
            {answers.map(answer => {
                let answerCount = stats[`answerCount${answer}`]
                let averageInfo = getAverageInfoForAnswer(stats, answer)
                let isCorrectAnswer = answer === correctAnswer

                return (
                    <div key={answer} className="text-center">
                        <ScantronBubble
                            letter={answer}
                            userAnswer={
                                (answerCount > 0 || isCorrectAnswer)
                                    ? answer
                                    : undefined
                            }
                            correctAnswer={correctAnswer}
                            disabled={true}
                        />

                        <div className="">
                            {averageInfo}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

function QuestionView({info}) {
    let {bellringerId, question, distractorAnswer, displayInfo, stats} = info
    let {subject, grade, week, questionNo, 
            questionText, questionImage, questionQualifier, correctAnswer,
            optionA, optionB, optionC, optionD,
        } = question

    let bellringersImage = getBellringersImageURL(questionImage)
    let alt = `Image of ${bellringerId}`
    let options = {optionA, optionB, optionC, optionD}
    let optionsInfo = {
        options,
        correctAnswer,
        distractorAnswer,
        stats
    }
    let statsInfo = {
        stats,
        correctAnswer,
        distractorAnswer
    }
    return (
        <div className="choices mb-4">
            <h4>Question {questionNo}</h4>

            <p>
                <MathKatex2 mixedContent={questionText}/>
            </p>

            {questionImage && (
                <img
                    src={bellringersImage}
                    alt={alt}
                />
            )}

            {questionQualifier && (
                <p>
                    <MathKatex2 mixedContent={questionQualifier}/>
                </p>
            )}

            <OptionsGroup info={optionsInfo}/>
        </div>
    )
}

function OptionsGroup({info}) {
        let {
        options,
        correctAnswer,
        stats
    } = info
    let {optionA, optionB, optionC, optionD} = options

    let answers = [
        {value: "A", content: optionA},
        {value: "B", content: optionB},
        {value: "C", content: optionC},
        {value: "D", content: optionD},
    ]

    return (
        <div className="answer-choices">
            {answers.map(answer => {
                let {value, content} = answer

                let isCorrect = value === correctAnswer

                let answerCount = stats[`answerCount${value}`]
                let wasSelected = answerCount > 0

                let className = "answer-choice"
                let wrapperClassName = "answer-choice-wrapper"
                if (isCorrect) {
                    className += " answer-choice--correct"
                    wrapperClassName += " correct"
                }
                else if (wasSelected) {
                    className += " answer-choice--selected"
                    wrapperClassName += " selected"
                }

                return (
                    <div
                        className={wrapperClassName}
                        key={value}
                    >
                        <div className={className}>
                            <span className="answer-choice--value">
                                {value}
                            </span>

                            &nbsp;

                            <MathKatex2 mixedContent={content != null ? String(content) : ""}/>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

function ExplanationsView({info}) {
    let {question, displayInfo, stats} = info
    let {correctAnswer, explanationA, explanationB, explanationC, explanationD} = question
    let explanations = {explanationA, explanationB, explanationC, explanationD}
    let explanationsInfo = {correctAnswer, explanations}

    return (
        <div className="full-exaplanation-sat--wrapper">
            <h4 className="full-exaplanation-sat--title">Explanation</h4>

            <div className="full-exaplanation-sat">
                <ExplanationsGroup explanations={explanations} correctAnswer={correctAnswer} stats={stats}/>
            </div>
        </div>
    )
}

function ExplanationsGroup({
    explanations,
    correctAnswer,
    stats
}: {
    explanations: any
    correctAnswer?: string
    stats?: any
}) {
    let {explanationA, explanationB, explanationC, explanationD} = explanations

    let answers = [
        {value: "A", content: explanationA},
        {value: "B", content: explanationB},
        {value: "C", content: explanationC},
        {value: "D", content: explanationD},
    ]

    return (
        <>
            {answers.map(answer => {
                let {value, content} = answer

                if (!content) return null

                let isCorrect = value === correctAnswer

                let answerCount = stats?.[`answerCount${value}`] || 0
                let wasSelected = answerCount > 0

                let className = "mb-4 explanation-choice"

                if (isCorrect) {
                    className += " correct"
                }
                else if (wasSelected) {
                    className += " selected"
                }

                return (
                    <div
                        className={className}
                        key={value}
                    >
                        <div className="answer-choice--value">{value}</div>
                        <MathKatex2 mixedContent={content}/>
                    </div>
                )
            })}
        </>
    )
}